// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport.js'
import { FieldsFactory } from '../Factory/FieldsFactory.js'

export let InitDataRequestInstrumentsGroup = function (pfixFieldSet)
{
    PFixFieldSet.call(this, FieldsFactory.INIT_DATA_REQUEST_INSTRUMENTS_GROUP, null, pfixFieldSet)
}
InitDataRequestInstrumentsGroup.prototype = Object.create(PFixFieldSet.prototype)